module.exports = __webpack_public_path__ + "img/default_user.b6681619.png";